<template>
  <div>
    <list row-key="id" ref="list" unit="库存管理" :query-params="params" size="small" :show-query="showQuery" :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success">导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="仓库名称">
          <el-select v-model="params.ckmc" placeholder="请选择">

          </el-select>
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input v-model="params.chmc" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="存货编码">
          <el-input v-model="params.chbm" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="params.ggxh" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="颜色">
          <el-input v-model="params.ys" placeholder="请输入内容" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ckmc" label="仓库名称" />
        <el-table-column prop="chmc" label="存货名称" />
        <el-table-column prop="chbm" label="存货编码" />
        <el-table-column prop="ggxh" label="规格型号" />
        <el-table-column prop="ys" label="颜色" />
        <el-table-column prop="zsl" label="主数量" />
        <el-table-column prop="zdw" label="主单位" />
        <el-table-column prop="fsl" label="辅数量" />
        <el-table-column prop="fdw" label="辅单位" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/statistics/rep").default,
      params: {
        ckmc: "",
        chmc: "",
        chbm: "",
        ggxh: "",
        ys: "",
      },
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 2, Data: [
          { ckmc: "开发部仓库", chmc: "ABS", chbm: "YL001", ggxh: "", ys: "", zsl: 10, zdw: "包", fsl: 100, fdw: "公斤" },
          { ckmc: "开发部仓库", chmc: "34556色粉", chbm: "SFL001", ggxh: "", ys: "红色", zsl: 2, zdw: "包", fsl: 30, fdw: "克" },
        ]})
      });
    },
  },
};
</script>